var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitterBlueIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7145 18.6226L28.4161 11H26.8282L21.0066 17.6172L16.3602 11H11L18.0277 21.0072L11 29H12.5879L18.7319 22.0104L23.6398 29H29L21.7145 18.6226ZM19.5389 21.0951L18.8258 20.098L13.1605 12.1713H15.5997L20.1732 18.5708L20.8833 19.5679L26.8275 27.8858H24.3882L19.5389 21.0951Z",
    fill: "#252153"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterBlueIcon);
export default __webpack_public_path__ + "static/media/twitter-blue-icon.d8e30d666c1b5009dce85c8c44e48f5e.svg";
export { ForwardRef as ReactComponent };